module.exports = __webpack_public_path__ + "img/logo-home.fe809fe1.svg";